<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    DrawerMenu(v-if="uid" :uid="uid" :show="showGlobalMenu" @close="toggleMenu")
    div.wrap-profile
      ModuleProfile(v-if="user" :user="user")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-profile {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header.vue'
import DrawerMenu from '@/components/shared/DrawerMenu'
import ModuleProfile from '@/components/module/ModuleProfile'

export default {
  components: {
    Auth, Header, DrawerMenu, ModuleProfile
  },
  data () {
    return {
      headerContent: {
        title: 'プロフィール',
        left: {
          icon: 'mdi-menu',
          action: this.toggleMenu 
        },
        right: {
          // label: '編集',
          icon: 'mdi-account-edit',
          to: '/profile-edit'
        }
      },
      showGlobalMenu: false,
      user: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    this.user = await database.userCollection().findById(this.$route.params.uid)
  },
  methods: {
    async onLoggedIn () {
    },
    toggleMenu () {
      this.showGlobalMenu = !this.showGlobalMenu
    }
  }
}
</script>
